import { urls } from "../constants";
import api from "./api";

const downloadAssignment = async ({ assignmentId, operatorId }) => {
  try {
    const response = await api.get(
      `${urls.downloadAssignment}/${assignmentId}`,
      {
        params: { operatorId },
        responseType: 'blob'
      }
    );

    return {
      status: response.status,
      doc: response.data,
      message: "Documento descargado de manera exitosa",
    };
  } catch (error) {
    // In this specific service, the previous code returned a structured object for error.
    // I will parse the blob if possible or return a generic message if it fails.
    // Axios stores the response data in error.response.data. If responseType is blob, error.response.data is a Blob.
    let message = error.message;
    if (error.response?.data instanceof Blob) {
      // If we wanted to read the error message from the blob, we'd need a FileReader, but that's async.
      // For now, defaulting to error.message or a generic one is safer.
      message = "Error al descargar el archivo";
    }

    return {
      status: error.response?.status || 400,
      message: message,
      doc: null,
    };
  }
};

const downloadOperatorAssignments = async ({ operatorId, laboratoryId }) => {
  try {
    const response = await api.get(
      `${urls.downloadOperatorAssignments}/${operatorId}`,
      {
        params: laboratoryId ? { laboratoryId } : {},
        responseType: 'blob'
      }
    );

    return {
      status: response.status,
      doc: response.data,
      message: "Documento descargado de manera exitosa",
    };
  } catch (error) {
    return {
      status: error.response?.status || 400,
      message: error.message || "Error al generar el PDF",
      doc: null,
    };
  }
};
const downloadAssignmentWithPatientData = async ({
  assignmentId,
  operatorId,
}) => {
  try {
    const response = await api.get(
      `${urls.downloadAssignmentWithPatientData}/${assignmentId}`,
      {
        params: { operatorId },
        responseType: 'blob'
      }
    );

    return {
      status: response.status,
      doc: response.data,
      message: "Documento descargado de manera exitosa",
    };
  } catch (error) {
    return {
      status: error.response?.status || 400,
      message: error.message || "Error al generar el PDF",
      doc: null,
    };
  }
};
const downloadOperatorAssignmentsWithPatientData = async ({ operatorId, laboratoryId }) => {
  try {
    const response = await api.get(
      `${urls.downloadOperatorAssignmentsWithPatientData}/${operatorId}`,
      {
        params: laboratoryId ? { laboratoryId } : {},
        responseType: 'blob'
      }
    );

    return {
      status: response.status,
      doc: response.data,
      message: "Documento descargado de manera exitosa",
    };
  } catch (error) {
    return {
      status: error.response?.status || 400,
      message: error.message || "Error al generar el PDF",
      doc: null,
    };
  }
};
const donwloadAssignmentServices = Object.freeze({
  downloadAssignment,
  downloadOperatorAssignments,
  downloadAssignmentWithPatientData,
  downloadOperatorAssignmentsWithPatientData,
});
export default donwloadAssignmentServices;
